module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-edit"
  }, [_c('modal', {
    staticClass: "edit-contact-modal",
    attrs: {
      "title": "",
      "open": _vm.isOpen
    },
    on: {
      "save": function($event) {
        return _vm.save()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "name": "email",
      "label": _vm.$t('ui.contact.caption.email'),
      "autofocus": true
    },
    model: {
      value: (_vm.workingContact.email),
      callback: function($$v) {
        _vm.$set(_vm.workingContact, "email", $$v)
      },
      expression: "workingContact.email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "name": "firstname",
      "label": _vm.$t('ui.contact.caption.firstname')
    },
    model: {
      value: (_vm.workingContact.firstname),
      callback: function($$v) {
        _vm.$set(_vm.workingContact, "firstname", $$v)
      },
      expression: "workingContact.firstname"
    }
  }), _vm._v(" "), _c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "name": "lastname",
      "label": _vm.$t('ui.contact.caption.lastname')
    },
    model: {
      value: (_vm.workingContact.lastname),
      callback: function($$v) {
        _vm.$set(_vm.workingContact, "lastname", $$v)
      },
      expression: "workingContact.lastname"
    }
  })], 1), _vm._v(" "), _c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "name": "business_card_job_title",
      "label": _vm.$t('ui.contact.caption.business_card_job_title')
    },
    model: {
      value: (_vm.workingContact.business_card_job_title),
      callback: function($$v) {
        _vm.$set(_vm.workingContact, "business_card_job_title", $$v)
      },
      expression: "workingContact.business_card_job_title"
    }
  }), _vm._v(" "), _c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "name": "company_department",
      "label": _vm.$t('ui.contact.caption.company_department')
    },
    model: {
      value: (_vm.workingContact.company_department),
      callback: function($$v) {
        _vm.$set(_vm.workingContact, "company_department", $$v)
      },
      expression: "workingContact.company_department"
    }
  }), _vm._v(" "), _c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "name": "phone_private",
      "label": _vm.$t('ui.contact.caption.phone_private')
    },
    model: {
      value: (_vm.workingContact.phone_private),
      callback: function($$v) {
        _vm.$set(_vm.workingContact, "phone_private", $$v)
      },
      expression: "workingContact.phone_private"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "name": "phone",
      "label": _vm.$t('ui.contact.caption.phone_company')
    },
    model: {
      value: (_vm.workingContact.phone_company),
      callback: function($$v) {
        _vm.$set(_vm.workingContact, "phone_company", $$v)
      },
      expression: "workingContact.phone_company"
    }
  }), _vm._v(" "), _c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "name": "mobile",
      "label": _vm.$t('ui.contact.caption.phone_mobile')
    },
    model: {
      value: (_vm.workingContact.phone_mobile),
      callback: function($$v) {
        _vm.$set(_vm.workingContact, "phone_mobile", $$v)
      },
      expression: "workingContact.phone_mobile"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('field', {
    attrs: {
      "name": "language",
      "label": _vm.$t('ui.contact.caption.language'),
      "type": "radio",
      "collection": [{
          value: 'en',
          name: 'English'
        },
        {
          value: 'de',
          name: 'German'
        }
      ]
    },
    model: {
      value: (_vm.workingContact.language),
      callback: function($$v) {
        _vm.$set(_vm.workingContact, "language", $$v)
      },
      expression: "workingContact.language"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "name": "gender",
      "label": _vm.$t('ui.contact.caption.gender'),
      "type": "radio",
      "collection": [{
          value: 'male',
          name: 'male'
        },
        {
          value: 'female',
          name: 'female'
        }
      ]
    },
    model: {
      value: (_vm.workingContact.gender),
      callback: function($$v) {
        _vm.$set(_vm.workingContact, "gender", $$v)
      },
      expression: "workingContact.gender"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e2fbe06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/contacts/ContactEdit.vue
// module id = 1878
// module chunks = 0